import React from 'react';
import { DropletIcon } from 'lucide-react';
interface LogoProps {
  tone?: 'light' | 'dark';
}
export function Logo({
  tone = 'light'
}: LogoProps) {
  const isDark = tone === 'dark';
  return <div className="flex items-center gap-2" data-id="element-41" data-mp="3qa352hi4wl4u">
      <span className={`flex h-8 w-8 items-center justify-center rounded-full ${isDark ? 'bg-brand-light' : 'bg-navy'}`} aria-hidden="true" data-id="element-42" data-mp="3qbeasmv542yl">
        <DropletIcon className={`h-4 w-4 ${isDark ? 'text-navy' : 'text-brand-light'}`} data-id="element-43" data-mp="mu5rdykrkv1r" />
      </span>
      <span className="font-serif text-xl font-extrabold leading-none tracking-tight sm:text-2xl" data-id="element-44" data-mp="rrffnawf30o0">
        <span className={isDark ? 'text-white/70' : 'text-navy/60'} data-id="element-45" data-mp="drmsfpk3n2ks">Dra.</span>
        <span className={isDark ? 'text-white' : 'text-navy'} data-id="element-46" data-mp="hsq9gfdvv4nl">Karito</span>
      </span>
    </div>;
}